 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {Editor} from 'draft-js'
import React from 'react'
import {useFragment} from 'react-relay'
import NotificationAction from '~/components/NotificationAction'

import useEditorState from '../hooks/useEditorState'
import useRouter from '../hooks/useRouter'
import {cardShadow} from '../styles/elevation'
import anonymousAvatar from '../styles/theme/images/anonymous-avatar.svg'
import fromStageIdToUrl from '../utils/meetings/fromStageIdToUrl'
import NotificationTemplate from './NotificationTemplate'

const EditorWrapper = styled('div')({
  backgroundColor: '#fff',
  borderRadius: 4,
  boxShadow: cardShadow,
  fontSize: 14,
  lineHeight: '20px',
  margin: '4px 0 0',
  padding: 8
})





const DiscussionMentioned = (props) => {
  const {notification: notificationRef} = props
  const notification = useFragment(
    graphql`
      fragment DiscussionMentioned_notification on NotifyDiscussionMentioned {
        ...NotificationTemplate_notification
        author {
          picture
          preferredName
        }
        meeting {
          id
          name
          ...fromStageIdToUrl_meeting
        }
        comment {
          content
        }
        discussion {
          stage {
            __typename
            id
            ... on TeamPromptResponseStage {
              response {
                id
              }
            }
          }
        }
      }
    `,
    notificationRef
  )
  const {history} = useRouter()
  const {meeting, author, comment, discussion} = notification
  const authorPicture = author ? author.picture : anonymousAvatar
  const authorName = author ? author.preferredName : 'Anonymous'
  const {stage} = discussion
  const {id: stageId, response} = _nullishCoalesce(stage, () => ( {}))
  const {id: meetingId, name: meetingName} = meeting

  const directUrl = stageId ? fromStageIdToUrl(stageId, meeting) : `/meet/${meetingId}`

  const goThere = () => {
    history.push(
      response ? `${directUrl}?responseId=${encodeURIComponent(response.id)}` : directUrl
    )
  }

  const [editorState] = useEditorState(comment.content)

  return (
    React.createElement(NotificationTemplate, {
      avatar: authorPicture,
      message: `${authorName} mentioned you in a discussion in ${meetingName}.`,
      notification: notification,
      action: React.createElement(NotificationAction, { label: 'See the discussion', onClick: goThere,} ),}

      , React.createElement(EditorWrapper, null
        , React.createElement(Editor, {
          readOnly: true,
          editorState: editorState,
          onChange: () => {
            /*noop*/
          },}
        )
      )
    )
  )
}

export default DiscussionMentioned
